import { useNavigate, useSearch } from "@tanstack/react-router";
import { useEffect } from "react";
import { z } from "zod";
import { LANGUAGES } from "./languages";
import { saveLanguage, useUserPrefs } from "./stores/user-prefs";

const langSchema = z.object({ lang: z.enum(LANGUAGES).optional() });

export const useLangParam = () => {
  const search = useSearch({ strict: false });
  const parsed = langSchema.safeParse(search);
  const lang = parsed.success ? parsed.data.lang : undefined;
  const navigate = useNavigate();
  const prefs = useUserPrefs();

  useEffect(() => {
    if (!lang || !prefs) return;

    if (prefs.language !== lang) {
      saveLanguage(lang);
    }

    const url = new URL(window.location.href);
    url.searchParams.delete("lang");
    navigate({ to: url.pathname + url.search, replace: true });
  }, [lang, prefs, navigate]);
};
